<mat-card>
	<mat-card-title id="NOTES_TITLE">Notes</mat-card-title>
	<hr />
	<mat-card-content class="card-content" fxLayoutGap="5px">
		<table *ngIf="notes && notes.length" mat-table [dataSource]="notes">
			<!-- Name Column -->
			<ng-container matColumnDef="name" sticky>
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element; let i = index">
					<span [id]="'NOTE_' + i + '_TITLE'">{{ element.name }} </span>
				</td>
			</ng-container>
			<!-- fieldType Column -->
			<ng-container matColumnDef="fieldType">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element; let i = index">
					<span [id]="'NOTE_' + i + '_FIELD_TYPE'">
						{{ element.fieldType }}
					</span>
				</td>
			</ng-container>
			<!-- pickListItems Column -->
			<ng-container matColumnDef="pickListItems">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element; let i = index">
					<span [id]="'NOTE_' + i + '_PICK_LIST_ITEMS'">
						<ng-container *ngFor="let note of element.pickListItems; let x = index">
							<p class="no-margin-tb">
								{{ note }}
							</p>
						</ng-container>
					</span>
				</td>
			</ng-container>
			<!-- actions Column -->
			<ng-container matColumnDef="actions" stickyEnd>
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element; let i = index" class="hover-icon" fxLayoutGap="20px">
					<mat-icon
						*ngIf="!isArchived"
						class="grey"
						(click)="openNoteDialog(payCategoryId, element, i, true)"
					>
						<span [id]="'NOTE_' + i + '_EDIT'">
							edit
						</span>
					</mat-icon>
					<mat-icon *ngIf="!isArchived" class="grey" (click)="deletePayCategoryNote(element, i)">
						<span [id]="'NOTE_' + i + '_DELETE'">
							delete
						</span>
					</mat-icon>
				</td>
			</ng-container>
			<tr mat-row *matRowDef="let row; columns: notesColumns"></tr>
		</table>

		<div *ngIf="!notes || !notes.length">There are no notes available.</div>
	</mat-card-content>

	<mat-card-actions>
		<div fxLayout="row" fxLayoutAlign="end center">
			<button
				*ngIf="!isArchived"
				id="NOTE_ADD"
				type="button"
				color="blue"
				mat-fab
				(click)="openNoteDialog(payCategoryId, null, null, false)"
			>
				<mat-icon>add</mat-icon>
			</button>
		</div>
	</mat-card-actions>
</mat-card>
